import React, { useMemo } from 'react';
import ExpandArraysContext from '../SchemaForm/ExpandArraysContext/ExpandArraysContext';
import FilesContext from '../SchemaForm/Widgets/FileWidget/FilesContext';
import RecordEditorForm from '../SchemaForm/RecordEditor/RecordEditorForm/RecordEditorForm';
import ValidateFocusFirstErrorContext from '../SchemaForm/ValidationForm/ValidateFocusFirstErrorContext';
export default function RecordEditorDrawerEditor(_ref) {
  var _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? true : _ref$defaultOpen,
    _ref$openOnError = _ref.openOnError,
    openOnError = _ref$openOnError === void 0 ? true : _ref$openOnError,
    fileMetadata = _ref.fileMetadata,
    fileUploadUrl = _ref.fileUploadUrl,
    _ref$focusFirstError = _ref.focusFirstError,
    focusFirstError = _ref$focusFirstError === void 0 ? false : _ref$focusFirstError,
    formData = _ref.formData,
    formRef = _ref.formRef,
    onChange = _ref.onChange,
    onValidate = _ref.onValidate,
    schema = _ref.schema,
    triggers = _ref.triggers,
    uiSchema = _ref.uiSchema,
    validateDirtyOnly = _ref.validateDirtyOnly;
  var expandArraysContext = useMemo(function () {
    return {
      defaultOpen: defaultOpen,
      openOnError: openOnError
    };
  }, [defaultOpen, openOnError]);
  var filesContext = useMemo(function () {
    return {
      files: fileMetadata,
      fileUploadUrl: fileUploadUrl
    };
  }, [fileMetadata, fileUploadUrl]);
  return /*#__PURE__*/React.createElement(ExpandArraysContext.Provider, {
    value: expandArraysContext
  }, /*#__PURE__*/React.createElement(FilesContext.Provider, {
    value: filesContext
  }, /*#__PURE__*/React.createElement(ValidateFocusFirstErrorContext.Provider, {
    value: focusFirstError
  }, /*#__PURE__*/React.createElement(RecordEditorForm, {
    formData: formData,
    formRef: formRef,
    indentFields: false,
    onChange: onChange,
    onValidate: onValidate,
    schema: schema,
    size: 'medium',
    triggerData: triggers,
    uiSchema: uiSchema,
    validateDirtyOnly: validateDirtyOnly
  }))));
}